module.exports = __webpack_public_path__ + "img/CtrlRoom_clock.640446f3.png";